import React, { Fragment, useState } from "react";
import { Row, Col, Card, Table, Button } from "react-bootstrap";
import Select from "react-select";
import { useSelector } from "react-redux";
import Loader from "../../../common/Loader";
import NoData from "../../../common/NoData";
import Pagination from "../../../common/Pagination/Pagination";
import { Translate } from "../../../Enums/Tranlate";
import { months } from "../../../Enums/Fixed";
import CardItem from "./CardItem";
import AddLeadsModal from "./AddLeadsModal";
import LeadService from "../../../../services/LeadService";
import "./style.scss";

const monthOptions = months.map((m, i) => ({ label: m, value: i + 1 }));

const currentYear = new Date().getFullYear();
const yearOptions = Array.from({ length: 6 }, (_, i) => ({
	label: `${currentYear - i}`,
	value: currentYear - i,
}));

const Leads = () => {
	const [data, setData] = useState([]);
	const [addModal, setAddModal] = useState(false);
	const [item, setItem] = useState({});
	const [hasData, setHasData] = useState(null);
	const [search, setSearch] = useState("");
	const [month, setMonth] = useState(null);
	const [year, setYear] = useState(null);
	const [loading, setLoading] = useState(false);
	const [shouldUpdate, setShouldUpdate] = useState(false);
	const lang = useSelector((state) => state.auth?.lang);
	const leadService = new LeadService();

	const param = {
		...(search ? { search } : {}),
		...(month ? { month: month.value } : {}),
		...(year ? { year: year.value } : {}),
	};

	return (
		<Fragment>
			<Card className="mb-3">
				<Card.Body className="search-card d-flex justify-content-between p-3 align-items-center">
					<div className="input-group w-50">
						<input
							type="text"
							style={{
								borderRadius: "8px",
								color: "initial",
								padding: "18px 16px",
							}}
							className="form-control"
							placeholder={
								Translate[lang]?.search_by_employee_name ||
								"Search by ID, lead name, or client name"
							}
							value={search}
							onChange={(e) => setSearch(e.target.value)}
						/>
						<div
							className="flaticon-381-search-2"
							style={{
								position: "absolute",
								zIndex: "1",
								right: lang === "en" && "16px",
								left: lang === "ar" && "16px",
								top: "50%",
								transform: "translate(0, -50%)",
							}}
						/>
					</div>
					<div className="add-department">
						<Button
							variant="primary"
							className="me-2 h-75"
							onClick={() => {
								setItem({});
								setAddModal(true);
							}}>
							<i className="la la-plus mx-1"></i>
							{Translate[lang]?.add} {Translate[lang]?.leads}
						</Button>
					</div>
				</Card.Body>
			</Card>

			<Row>
				<Col lg={12}>
					<Card>
						<Card.Body>
							<Row className="mb-3 align-items-end g-3">
								<Col md={3}>
									<Select
										isClearable
										placeholder={Translate[lang]?.month || "Month"}
										options={monthOptions}
										value={month}
										onChange={(e) => {
											setMonth(e);
											setShouldUpdate((prev) => !prev);
										}}
									/>
								</Col>
								<Col md={3}>
									<Select
										isClearable
										placeholder={Translate[lang]?.year || "Year"}
										options={yearOptions}
										value={year}
										onChange={(e) => {
											setYear(e);
											setShouldUpdate((prev) => !prev);
										}}
									/>
								</Col>
								<Col md={2}>
									<Button
										variant="primary"
										className="w-100"
										onClick={() => setShouldUpdate((prev) => !prev)}>
										{Translate[lang]?.search}
									</Button>
								</Col>
							</Row>

							{loading && (
								<div style={{ height: "300px" }}>
									<Loader />
								</div>
							)}
							{hasData === 1 && !loading && (
								<Table responsive>
									<thead>
										<tr className="text-center">
											<th>
												<strong>{Translate[lang]?.lead_name}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.client_name}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.client_phone}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.client_email}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.reference}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.attachments}</strong>
											</th>
											{/* <th>
												<strong>{Translate[lang]?.status}</strong>
											</th> */}
											<th></th>
										</tr>
									</thead>
									<tbody className="table-body">
										{data?.map((item, index) => (
											<CardItem
												key={item.id || index}
												index={index}
												item={item}
												setItem={setItem}
												setAddModal={setAddModal}
												setShouldUpdate={setShouldUpdate}
											/>
										))}
									</tbody>
								</Table>
							)}
							{hasData === 0 && (
								<div className="text-center">
									<NoData />
								</div>
							)}
							<Pagination
								setData={setData}
								service={leadService}
								shouldUpdate={shouldUpdate}
								setHasData={setHasData}
								setLoading={setLoading}
								search={search}
								param={param}
							/>
						</Card.Body>
					</Card>
				</Col>
			</Row>

			{addModal && (
				<AddLeadsModal
					item={item}
					addModal={addModal}
					setShouldUpdate={setShouldUpdate}
					setAddModal={() => setAddModal(false)}
				/>
			)}
		</Fragment>
	);
};

export default Leads;
